if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.prependMedia = this.dataset.disablePrepend != 'true';
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;
      // Raven's variant group includes a video and detail photos, not just its hero.
      if (this.dataset.gbRavenMediaOrder) {
        this.ravenVariantListener = (event) => {
          const picker = event.target.closest('variant-selects, variant-radios');
          if (!picker || picker.dataset.section !== this.dataset.section) return;
          const values = Array.from(picker.querySelectorAll('select, input[type="radio"]:checked')).map(input => input.value);
          const camo = values.some(value => /camo/i.test(value));
          this.orderRavenMedia(camo);
          const heroId = this.ravenCamoOrder()[0];
          if (camo && heroId) {
            this.setActiveMedia(`${this.dataset.section}-${heroId}`, false);
          }
        };
      }
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    connectedCallback() {
      if (this.ravenVariantListener) document.addEventListener('change', this.ravenVariantListener);
    }

    disconnectedCallback() {
      if (this.ravenVariantListener) document.removeEventListener('change', this.ravenVariantListener);
    }

    ravenCamoOrder() {
      return (this.dataset.gbRavenCamoOrder || '').split(',').filter(Boolean);
    }

    orderRavenMedia(camo) {
      if (!this.dataset.gbRavenMediaOrder) return;
      const original = this.dataset.gbRavenMediaOrder.split(',');
      const priority = camo ? this.ravenCamoOrder() : [];
      const order = [...new Set([...priority, ...original])];
      const mediaId = node => (node.dataset.mediaId || node.dataset.target || '').split('-').pop();
      for (const list of [this.elements.viewer.querySelector('[id^="Slider-Gallery"]'), this.elements.thumbnails?.querySelector('[id^="Slider-Thumbnails"]')]) {
        if (!list) continue;
        const nodes = Array.from(list.children);
        nodes.sort((a, b) => order.indexOf(mediaId(a)) - order.indexOf(mediaId(b)));
        if (nodes.some((node, index) => node !== list.children[index])) nodes.forEach(node => list.appendChild(node));
      }
      for (const slider of [this.elements.viewer, this.elements.thumbnails]) {
        if (slider?.resetPages) slider.resetPages();
      }
      this.elements.thumbnails?.querySelectorAll('[data-media-position]').forEach((node, index) => node.dataset.mediaPosition = index + 1);
    }

    onSlideChanged(event) {
      const current = event && event.detail && event.detail.currentElement;
      if (!current || !this.elements.thumbnails) return;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ current.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      if (prepend && this.dataset.gbRavenMediaOrder) {
        const heroId = this.ravenCamoOrder()[0];
        this.orderRavenMedia(!!heroId && String(mediaId).endsWith(`-${heroId}`));
      }
      if (filtering && currentVariant) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
        allSlides.forEach(slide => {
          if (slide.dataset.alt === currentVariant[this.filteringOption] || slide.dataset.alt === 'always_display') {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        })
      }

      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend && this.prependMedia) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          if (activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (filtering && currentVariant) {
        if (this.elements.viewer && this.elements.viewer.initPages) this.elements.viewer.initPages();
        if (this.elements.viewer && this.elements.viewer.update) this.elements.viewer.update();
      }

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      if (!activeThumbnail) return;
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, false, 10, true)) return;

      if (this.elements.thumbnails.vertical) {
        console.log('setActiveThumbnail')
        this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
      } else {
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
